import { Box, Text } from '@bpba/ui-components';

type TituloProps = {
  icono?: string;
  detalle?: boolean;
  children: string | undefined;
  ariaLabel?: string;
  tabIndex?: number;
};

export const Titulo = (props: TituloProps) => {
  return (
    <Box
      display={'flex'}
      flexDirection={'row'}
      alignItems={'center'}
      marginBottom={props.detalle ? ['16px', '0px'] : ['0px']}
      aria-label={props.ariaLabel || props.children}
      tabIndex={props.tabIndex || 0}
    >
      {props.icono && (
        <Box
          height={['50px', '60px']}
          width={['50px', '60px']}
          dangerouslySetInnerHTML={{
            __html: props.icono,
          }}
        ></Box>
      )}
      <Text fontSize={props.detalle ? ['16px', '20px'] : ['24px']} lineHeight={'28px !important'} fontWeight={'500'}>
        {props.children}
      </Text>
    </Box>
  );
};
